export default "__VITE_ASSET__Fhalkml___"